<div *ngIf="global_texts" class="all-content">
  <div class="content align-items-center justify-content-center p-3">

    <div>
      <a class="py-4 d-inline-block" role="button" [routerLink]="'/'">
        <svg>
          <use xlink:href="#logo_spinner"></use>
        </svg>
      </a>
    </div>
    <h1 class="error-title" [innerHtml]="global_texts.error_page?.title"></h1>
    <h1 class="error-number" [innerHtml]="global_texts.error_page?.subtitle"></h1>
    <p class="fw-bold mt-4" [innerHtml]="global_texts.error_page?.message"></p>
  </div>
</div>
